import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Section, Spinner } from "../components/Bits";
import PageHero from "../components/PageHero";
import { TourBadges, WhatWeDontDo, formatTourDate } from "../components/TourBits";
import { ArrowRight, Calendar } from "lucide-react";

const INTRO = "Wildkräuter sicher erkennen, den Wald im Wandel verstehen oder fremden Arten vor unserer Haustür auf die Spur kommen. Kostenlos, für Erwachsene, in kleinen Gruppen bis 15 Personen – keine Vorkenntnisse nötig.";

function TourCard({ t }) {
  const next = (t.dates || [])[0];
  return (
    <Link to={`/tours/${t.slug}`} className="plant-card group overflow-hidden flex flex-col" data-testid={`tour-card-${t.slug}`}>
      <div className="aspect-[4/3] overflow-hidden">
        <img src={t.image_url} alt={t.image_alt || t.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display text-2xl mb-3">{t.title}</h3>
        <TourBadges tour={t} testId={`tour-badges-${t.slug}`} />
        <p className="text-sm opacity-80 mt-4 flex-1">{t.short_description}</p>
        <div className="mt-5 text-sm flex items-center gap-2" style={{ color: "var(--wp-olive)" }} data-testid={`tour-next-${t.slug}`}>
          <Calendar className="w-4 h-4" />
          {next ? `Nächster Termin: ${formatTourDate(next.date, { weekday: "short", year: undefined })}` : "Die nächsten Termine folgen bald."}
        </div>
        <span className="btn-primary mt-5 justify-center">{next ? "Termine & Anmeldung" : "Mehr erfahren"} <ArrowRight className="w-4 h-4" /></span>
      </div>
    </Link>
  );
}

export default function Tours() {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/tours").then((r) => setTours(r.data || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="tours-page">
      <PageHero slug="tours"
        defaultImage="/fotos/guide-wiese.webp"
        imageAlt="Michèle zeigt auf einer Wiese eine Pflanze – geführte Naturwanderung"
        imagePosition="center 30%"
        defaultOverline="Geführte Touren"
        defaultTitle="Komm mit uns raus."
        defaultSubtitle={INTRO}
      />
      <Section>
        {loading ? (
          <Spinner />
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="tours-grid">
            {tours.map((t) => <TourCard key={t.id} t={t} />)}
          </div>
        )}
        <div className="mt-16">
          <WhatWeDontDo testId="tours-what-we-dont-do" />
        </div>
      </Section>
    </div>
  );
}
